/* Behaviour for snippets/kq-product-card.liquid: variant dropdown updates price and
   button, quantity stepper, add to cart via /cart/add.js.

   Adapted from the script inside sections/featured-collection--stack.liquid. That one
   scoped everything to a section id; this one works per card, so any number of
   sections can render the card and the script is loaded once. */
(function () {
  'use strict';
  if (window.kqProductCardInit) return;
  window.kqProductCardInit = true;

  function money(cents) {
    if (window.Shopify && Shopify.formatMoney && window.kqMoneyFormat) {
      return Shopify.formatMoney(cents, window.kqMoneyFormat);
    }
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function productData(card) {
    var el = card.querySelector('.stack_product-json');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function findVariant(product, selected) {
    return product.variants.find(function (v) {
      return (selected[0] === undefined || v.option1 === selected[0]) &&
             (selected[1] === undefined || v.option2 === selected[1]) &&
             (selected[2] === undefined || v.option3 === selected[2]);
    });
  }

  function updatePrice(card, variant) {
    var wrap = card.querySelector('.stack_card-price');
    if (!wrap) return;
    var current = wrap.querySelector('.stack_price-current');
    var compare = wrap.querySelector('.stack_price-compare');
    if (current) current.textContent = money(variant.price);
    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    if (onSale) {
      if (!compare) {
        compare = document.createElement('span');
        compare.className = 'stack_price-compare';
        wrap.querySelector('.price_container').appendChild(compare);
      }
      compare.innerHTML = '<s>' + money(variant.compare_at_price) + '</s>';
      compare.hidden = false;
    } else if (compare) {
      compare.hidden = true;
    }
  }

  function updateButton(card, variant) {
    var btn = card.querySelector('.stack_atc-btn');
    if (!btn) return;
    btn.setAttribute('data-variant-id', variant ? variant.id : '');
    var ok = variant && variant.available;
    btn.disabled = !ok;
    if (ok) btn.removeAttribute('aria-disabled'); else btn.setAttribute('aria-disabled', 'true');
    btn.textContent = ok ? btn.getAttribute('data-atc-text') : btn.getAttribute('data-sold-out-text');
  }

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('.kq-cards select.stack_option-btn');
    if (!sel) return;
    var card = sel.closest('.stack_product-card');
    var product = card && productData(card);
    if (!product) return;
    var selected = [0, 1, 2].map(function (i) {
      var s = card.querySelector('select.stack_option-btn[data-option-index="' + i + '"]');
      return s ? s.value : undefined;
    });
    var variant = findVariant(product, selected);
    if (!variant) return;
    updatePrice(card, variant);
    updateButton(card, variant);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.kq-cards .stack_qty-btn');
    if (!btn) return;
    var val = btn.closest('.stack_qty-control').querySelector('.stack_qty-val');
    var n = parseInt(val.textContent, 10) || 1;
    if (btn.classList.contains('stack_qty-minus')) { if (n > 1) val.textContent = n - 1; }
    else val.textContent = n + 1;
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.kq-cards .stack_atc-btn');
    if (!btn || btn.disabled) return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    var card = btn.closest('.stack_product-card');
    var qtyEl = card.querySelector('.stack_qty-val');
    var qty = qtyEl ? parseInt(qtyEl.textContent, 10) || 1 : 1;
    var original = btn.textContent;
    btn.classList.add('stack_loading');
    btn.textContent = '...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function () {
        btn.classList.remove('stack_loading');
        btn.classList.add('stack_success');
        btn.textContent = '✓ Added';
        var counts = document.querySelectorAll('[data-cart-count], .cart-count, .cart__count, #CartCount, .header__cart-count');
        if (counts.length) {
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            counts.forEach(function (el) { el.textContent = cart.item_count; });
          }).catch(function () {});
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'kq-product-card' } }));
        setTimeout(function () { btn.classList.remove('stack_success'); btn.textContent = original; }, 2000);
      })
      .catch(function (err) {
        btn.classList.remove('stack_loading');
        btn.textContent = original;
        console.warn('[kq-product-card] add to cart failed:', err);
      });
  });
})();
